export default __webpack_public_path__ + "locales/pt/OAuth.json?hash=4f577157ce35ef65cd985f12ede432f1";